import { FlexProps } from "antd";

import { StyledContainer, Mask, ContentWrapper } from "./styles";
import { useClientSettings } from "@hooks/useClientSettings";

/** Clientes cujo fundo já traz a composição final e não deve ser desfocado. */
const DISABLE_BACKGROUND_BLUR_CLIENTS = new Set([
  "ageucard",
  "pagoal",
  "tafácil",
]);

/** Clientes cujo fundo deve ficar centralizado. */
const CENTER_BACKGROUND_CLIENTS = new Set(["pagoal", "tafácil"]);

type ContainerWithImageBgProps = FlexProps & {
  hideImage?: boolean;
};

export const ContainerWithImageBg = ({
  children,
  hideImage,
  ...props
}: ContainerWithImageBgProps) => {
  const client = useClientSettings();
  const clientName = client.name.toLowerCase();
  return (
    <StyledContainer>
      <Mask
        $hideImage={hideImage || !client.assets.background}
        $disableBackgroundBlur={DISABLE_BACKGROUND_BLUR_CLIENTS.has(clientName)}
        $centerBackground={CENTER_BACKGROUND_CLIENTS.has(clientName)}
      />

      <ContentWrapper vertical {...props}>
        {children}
      </ContentWrapper>
    </StyledContainer>
  );
};

export default ContainerWithImageBg;
